import { handleActions } from 'redux-actions';
import { READY } from '../../actions/types';
import { subscriptions } from '@/config';

const INITIAL_STATE = null;
// eslint-disable-next-line import/prefer-default-export
export const reducer = handleActions(
  {
    [READY]: (state, { payload }) => state
      || subscriptions(payload).map(item => ({
        ...item,
      })),
  },
  INITIAL_STATE,
);
